import SoefiaStartingPanel from './SoefiaStartingPanel'
import SoefiaPromptPanel from './SoefiaPromptPanel'

export default ({
  questionObj = {},
  currentQuestionStep = '',
  answers,
  setAnswers,
  largeFonts,
  extraLargeFonts,
  setIsRecordingInProgress
}) => {
  const {
    id: questionId,
    soefiaConfig = {}
  } = questionObj

  const getCurrentPanel = () => {
    if (currentQuestionStep === 0) {
      return (
        <SoefiaStartingPanel 
          soefiaConfig={soefiaConfig}
          questionId={questionId}
          answers={answers} 
          setAnswers={setAnswers}
          setIsRecordingInProgress={setIsRecordingInProgress}
        />
      )
    } else {
      return (
        <SoefiaPromptPanel 
          soefiaConfig={soefiaConfig} 
          currentQuestionStep={currentQuestionStep} 
          questionId={questionId} 
          answers={answers} 
          setAnswers={setAnswers}
          largeFonts={largeFonts}
          extraLargeFonts={extraLargeFonts}
          setIsRecordingInProgress={setIsRecordingInProgress}
        />
      )
    }
  }

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '40px 140px 20px 140px'
    }}>
      {getCurrentPanel()}
    </div>
  )
}